import { render, staticRenderFns } from "./OrganizationsTable.vue?vue&type=template&id=3c8c21e7"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports